/* eslint-disable no-useless-concat */
import React, { Fragment, useEffect, useState } from "react";

import { styled } from "@mui/material/styles";

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Toolbar,
  IconButton,
  Tooltip,
  Button,
  Typography,
  Drawer,
  Box,
  Icon,
} from "@mui/material";

import { useForm } from "react-hook-form";
import { FilterList, Clear, Add, Search, Print } from "@mui/icons-material";
import { gql, useQuery } from "@apollo/client";
import clsx from "clsx";
import MUIselect from "../HOC/MUI/MUIselect";
import { LIST_PAYMENT_QUERY } from "./PaymentListQuary";
import moment from "moment";
import { urlParameters } from "../HOC/CustomFunctions/urlParameters";
import MUITablePagination from "../HOC/MUI/TablePagination/MUITablePagination";
import MUIDateRangeCustom from "../HOC/MUI/MUIDateRangeCustom";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { Can, SecuredNavLink } from "../HOC/CustomComponents/Secured";
import emptyList from "../../assets/Image/received.png";
import { windowUrl } from "../HOC/CustomFunctions/pushUrl";
import { CustomAutocomplete } from "../HOC/MUI/CustomAutocomplete";
import ControlMUItextField from "../HOC/MUI/ControlMUItextField";
import CellLink from "../HOC/CustomComponents/CellLink";
import {
  LIST_CUSTOMERS_DROPDOWN,
  LIST_DELIVERY_AGENTS_DROPDOWN,
  LSIT_ZONES_DROPDOWN,
  LIST_SAFES_DROPDOWN,
  LIST_BRANCHES_DROPDOWN,
} from "../../GlobalsQuery/ListDropdown/ListDropdown";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import TableFixedHeaderWraper from "../HOC/CustomComponents/TableWithFixedHeader";
import LookupDropdown from "../HOC/CustomComponents/LookupDropdown";
import { lookupCodeIsValid } from "../HOC/CustomFunctions/lookupCodeIsValid";
import useWidth from "../../Hooks/useWidth";
import { dateFormatLL } from "../../helpers/dateFunctions";
import ExportPaymentList from "./ExportPaymentList";
import { GetPaymentPermissionSlug } from "../../helpers/getManifestPermissionSlug";

const PREFIX = "PaymentList";

const classes = {
  track: `${PREFIX}-track`,
  typo: `${PREFIX}-typo`,
  mainTracking: `${PREFIX}-mainTracking`,
  appBar: `${PREFIX}-appBar`,
  title: `${PREFIX}-title`,
  textAlign: `${PREFIX}-textAlign`,
  divider: `${PREFIX}-divider`,
  paper: `${PREFIX}-paper`,
  filterAnchor: `${PREFIX}-filterAnchor`,
  picker: `${PREFIX}-picker`,
  button: `${PREFIX}-button`,
  toolbar: `${PREFIX}-toolbar`,
  selectPadding: `${PREFIX}-selectPadding`,
  margin: `${PREFIX}-margin`,
  titles: `${PREFIX}-titles`,
  filterForm: `${PREFIX}-filterForm`,
  filterField: `${PREFIX}-filterField`,
  tableIcon: `${PREFIX}-tableIcon`,
  drawer: `${PREFIX}-drawer`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  drawerHeader: `${PREFIX}-drawerHeader`,
  content: `${PREFIX}-content`,
  contentShift: `${PREFIX}-contentShift`,
  iconColor: `${PREFIX}-iconColor`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.track}`]: {
    marginTop: theme.spacing(2),
  },

  [`& .${classes.typo}`]: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontWeight: 600,
  },

  [`& .${classes.mainTracking}`]: {
    margin: theme.spacing(0, 0),
    width: "100%",
  },

  [`& .${classes.appBar}`]: {
    position: "relative",
  },

  [`& .${classes.title}`]: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },

  [`& .${classes.textAlign}`]: {
    textAlign: "justify",
    padding: theme.spacing(1),
  },

  [`& .${classes.divider}`]: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "1px",
    },
  },

  [`& .${classes.paper}`]: {
    display: "grid",
    width: "100%",
    marginBottom: theme.spacing(2),
    borderRadius: 0,
  },

  [`& .${classes.filterAnchor}`]: {
    [theme.breakpoints.down("md")]: {
      width: "auto",
    },
    // overflowX: "scroll",
    "& .MuiDrawer-paper": {
      [theme.breakpoints.up("sm")]: {
        width: "30%",
      },
    },
  },

  [`& .${classes.picker}`]: {
    [theme.breakpoints.down("md")]: {
      width: "auto",
    },
    // overflow: "scroll",
    "& .MuiDrawer-paper": {
      [theme.breakpoints.up("sm")]: {
        width: "50%",
      },

      height: "100%",
      overflow: "hidden",
    },
  },

  [`& .${classes.button}`]: {
    position: "sticky",
    bottom: 0,
    zIndex: 1,
    backgroundColor: "#fff",
    marginTop: 10,
    padding: 7,
  },

  [`& .${classes.toolbar}`]: {
    borderBottom: "solid 1px",
    borderBottomColor: theme.palette.divider,
    // zIndex: "1300",
    // justify: "space-between"
  },

  [`& .${classes.selectPadding}`]: {
    paddingTop: "6px",
    paddingBottom: "5px",
  },

  [`& .${classes.margin}`]: {
    margin: theme.spacing(1, 2),
  },

  [`& .${classes.titles}`]: {
    flex: "1 1 100%",
  },

  [`& .${classes.filterForm}`]: {
    overflowY: "auto",
    width: "100%",
    margin: 0,
    position: "relative",
    height: "100vh",
  },

  [`& .${classes.filterField}`]: {
    padding: theme.spacing(1),
    width: "100%",
    margin: 0,
  },

  [`& .${classes.tableIcon}`]: {
    margin: theme.spacing(0, 1),
  },

  /////////Drawer///////////

  [`& .${classes.drawer}`]: {
    width: drawerWidth,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      // height: "100%",
    },
  },

  [`& .${classes.drawerPaper}`]: {
    width: drawerWidth,

    zIndex: "250",

    left: "initial",
    right: "initial",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },

  [`& .${classes.drawerHeader}`]: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },

  [`& .${classes.content}`]: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },

  [`& .${classes.contentShift}`]: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: "auto",
    width: "calc(100% - 240px)",
    [theme.breakpoints.down("sm")]: {
      margin: "auto",
      width: "auto",
    },
  },

  [`& .${classes.iconColor}`]: {
    color: theme.palette.success.main,
  },
}));

///////////////////////////////////////////////////

//////////////////////////////////////////////////
const drawerWidth = 240;

function EnhancedTableHead(props) {
  //*********Table Function*********
  const { t } = useTranslation();
  const headCells = [
    { id: "1", numeric: true, disablePadding: false, label: t("recordCode") },
    { id: "2", numeric: true, disablePadding: false, label: t("paymentDate") },
    {
      id: "3",
      numeric: true,
      disablePadding: false,
      label: t("shippingAgent"),
    },
    { id: "4", numeric: true, disablePadding: false, label: t("safe") },
    { id: "6", numeric: true, disablePadding: false, label: t("value") },
    { id: "7", numeric: true, disablePadding: false, label: t("approved") },
    { id: "8", numeric: true, disablePadding: false, label: t("glApproved") },
  ];
  if (props.type === "custm") {
    const referenceBranch = {
      id: "5",
      numeric: true,
      disablePadding: false,
      label: t("returningDueFees"),
    };
    headCells.splice(4, 0, referenceBranch);
  }
  if (props.type === "dlvby") {
    const shipmentsNumber = {
      id: "9",
      numeric: true,
      disablePadding: false,
      label: t("shipments"),
    };
    headCells.splice(4, 0, shipmentsNumber);
    const referenceBranch = {
      id: "10",
      numeric: true,
      disablePadding: false,
      label: t("pickups"),
    };
    headCells.splice(5, 0, referenceBranch);
  }
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          if (props.type === "custm" && headCell["id"] === "3") {
            headCell["label"] = t("customer");
          } else if (props.type === "dlvby" && headCell["id"] === "3") {
            headCell["label"] = t("shippingAgent");
          }
          return (
            <FixedTableCell
              key={headCell.id}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </FixedTableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

/////////////////DIALOG///////////////

const initDate = moment(new Date()).locale("en").format("YYYY-MM-DD");

const PaymentList = (props) => {
  const urlQuery = urlParameters(window.location.search);
  const screenWidth = useWidth();
  const listType = props.match.params.type;
  const history = useHistory();
  const { t } = useTranslation();
  const paymentTitles = {
    dlvby: t("deliveryAgentPayment"),
    custm: t("customerPayment"),
  };
  const filterAnchor = screenWidth === "xs" ? "bottom" : "left";

  const validUrlParameters = Object.keys(urlQuery).length !== 0 && !Object.keys(urlQuery).includes("fromDate", "toDate");

  const initFromDate = urlQuery["fromDate"]
    ? urlQuery["fromDate"]
    : validUrlParameters ? null : initDate;
  const initToDate = urlQuery["toDate"]
    ? urlQuery["toDate"]
    : validUrlParameters ? null : initDate;
  const [dateRange, setDateRange] = useState([initFromDate, initToDate]);
  const fromDate = moment(dateRange[0]).locale("en").format("YYYY-MM-DD");
  const toDate = moment(dateRange[1]).locale("en").format("YYYY-MM-DD");



  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [queryVar, setQuaryVar] = useState(null);

  const [state, setState] = React.useState({
    top: true,
    left: screenWidth === "xs" ? false : true,
    bottom: screenWidth === "xs" ? false : true,
    right: screenWidth === "xs" ? false : true,
  });

  const [autocompleteValues, setAutocompleteValues] = useState({
    deliveryAgent: null,
    customer: null,
    toZone: null,
    toSubzone: null,
    fromZone: null,
    fromSubzone: null,
  });

  const handelAutocompleteDefaultValue = (data, id, fieldName) => {
    const defaultValue = data[Object.keys(data)[0]].find(
      (i) => i.id === parseInt(id)
    );
    defaultValue &&
      setAutocompleteValues((prev) => ({
        ...prev,
        [fieldName]: defaultValue,
      }));
  };

  const lookupsComplete = (data, updateValue, name) => {
    if (updateValue && lookupCodeIsValid(data, updateValue)) {
      setValue(name, updateValue);
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const resetDate = () => {
    setDateRange([null, null]);
  };
  const parseData = (data) => {
    return data;
  };

  const {
    formState: { errors },
    handleSubmit,
    control,
    watch,
    setValue,
  } = useForm();


  const searchParams = (param) => {
    const queryParams = [];
    for (const i in param) {
      encodeURIComponent(param[i]) &&
        queryParams.push(
          encodeURIComponent(i) + "=" + encodeURIComponent(param[i])
        );
    }
    const queryString = queryParams.join("&");
    return queryString;
  };

  const pushUrlSearch = (param) => {
    const params = searchParams(param);

    const url = history.createHref({
      pathname: `/admin/payments/${listType}`,
      search: "?" + params,
    });
    windowUrl(url);
  };

  useEffect(() => {
    const { first, page, ...input } = urlQuery;
    if (input["code"]) input["code"] = input["code"].toString();
    setQuaryVar((prev) => ({
      ...(dateRange[0] && { fromDate }),
      ...(dateRange[1] && { toDate }),
      ...prev,
      ...input,
      type: listType.toUpperCase(),
    }));
    urlQuery["code"] && setValue("code", urlQuery["code"].toString());
    urlQuery["approved"] !== undefined &&
      setValue("approved", urlQuery["approved"]);
    urlQuery["glApproved"] !== undefined &&
      setValue("glApproved", urlQuery["glApproved"]);
    urlQuery["first"] && setRowsPerPage(parseInt(urlQuery["first"]));
    urlQuery["page"] && setPage(parseInt(urlQuery["page"] - 1));
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    pushUrlSearch({ ...urlQuery, page: newPage + 1 });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    pushUrlSearch({ ...urlQuery, page: 1, first: +event.target.value });
  };
  const onSubmit = (data) => {
    data["fromDate"] = dateRange[0] && fromDate;
    data["toDate"] = dateRange[1] && toDate;
    filterAnchor === "bottom" &&
      setState((prev) => ({ ...prev, [filterAnchor]: false }));
    for (const key in data) {
      if (data[key] === "" || data[key] === null) {
        delete data[key];
      }
    }
    pushUrlSearch({
      ...data,
      first: rowsPerPage,
      page: 1
    });
    setQuaryVar({
      ...data,
      ...(dateRange[0] && {
        fromDate
      }),
      ...(dateRange[1] && {
        toDate
      }),
      type: listType.toUpperCase(),
    });
    setPage(0);
  };

  // List Query
  const { data, loading } = useQuery(
    gql`
      ${LIST_PAYMENT_QUERY.query}
    `,
    {
      notifyOnNetworkStatusChange: true,
      skip: !queryVar,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      variables: {
        first: rowsPerPage,
        page: page + 1,
        input: {
          ...queryVar,
        },
      },
      onCompleted: (data) => { },
    }
  );
  const paymentData =
    data?.listPayments?.data !== null ? data?.listPayments?.data : null;
  const sumPayments = data?.sumPayments;

  const onPrint = (param) => {
    const params = searchParams(queryVar);
    const domain = `${window.location.origin}`;

    window.open(`${domain}${param}?${params}`);
  };
  const emptyListPayments = data?.listPayments?.data?.length === 0;
  const EnhancedTableToolbar = (props) => {
    const { exportFilters } = props;
    return (
      <Toolbar className={clsx(classes.toolbar)} variant="dense">
        <Typography
          className={classes.titles}
          color="inherit"
          variant="h6"
          component="div"
        >
          {paymentTitles[`${listType}`]}
        </Typography>

        <Tooltip title="Filter list">
          <IconButton
            aria-label="filter list"
            onClick={() => props.filter()}
            size="large"
          >
            <FilterList />
          </IconButton>
        </Tooltip>

        <ExportPaymentList
          disabled={Boolean(data?.listPayments?.data?.length === 0)}
          filters={exportFilters}
        />

        <Tooltip title="print list">
          <Box component="span">
            <IconButton
              aria-label="filter list"
              size="large"
              onClick={() => onPrint("/payments/print")}
              disabled={emptyListPayments}
            >
              <Print />
            </IconButton>
          </Box>
        </Tooltip>

        <Tooltip title="print details">
          <Box component="span">
            <IconButton
              aria-label="filter list"
              size="large"
              color="primary"
              onClick={() =>
                onPrint(`/report/print/payment/n/${listType.toUpperCase()}`)
              }
              disabled={emptyListPayments}
            >
              <Print />
            </IconButton>
          </Box>
        </Tooltip>

        <SecuredNavLink
          permission={GetPaymentPermissionSlug(listType, 'create')}
          to={{ pathname: `/admin/payments/create/${listType}` }}
        >
          <Tooltip title="Add shipment">
            <IconButton
              aria-label="filter list"
              className={classes.addIcon}
              size="large"
            >
              <Add color="primary" />
            </IconButton>
          </Tooltip>
        </SecuredNavLink>
      </Toolbar>
    );
  };

  EnhancedTableToolbar.propTypes = {};

  let paymentBody = null;
  paymentBody = (
    <Grid container item xs={12} justifyContent="center" sx={{ width: "100%" }}>
      {/* *******Table******* */}
      <Grid container item>
        <Paper className={clsx(classes.paper)}>
          <EnhancedTableToolbar
            filter={toggleDrawer(filterAnchor, true)}
            exportFilters={queryVar}
            {...props}
          />
          {loading || paymentData?.length === 0 ? (
            <Grid
              container
              item
              justifyContent="center"
              className={classes.track}
            >
              {loading ? (
                <FullScreenLoading minHeight='15%' />
              ) : (
                <Box textAlign="center">
                  <img width="50%" src={emptyList} alt={"delivery box"} />
                  <Box
                    component={Typography}
                    variant="h6"
                    color="text.secondary"
                    marginTop="0"
                  >
                    {t("searchNoResult")}
                  </Box>
                </Box>
              )}
            </Grid>
          ) : (
            <TableFixedHeaderWraper>
              <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                <EnhancedTableHead
                  rowCount={paymentData?.length}
                  type={listType}
                />
                <TableBody>
                  {paymentData &&
                    paymentData?.map((row, index) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      // onClick={(e) => {
                      //   e.stopPropagation();
                      //   pushUrl(props, `/admin/payments/${row?.id}/edit`);
                      // }}
                      >
                        <CellLink
                          pathname={`/admin/payments/${row?.id}`}
                          component="th"
                          scope="row"
                        >
                          {row.code}
                        </CellLink>
                        <FixedTableCell>
                          {dateFormatLL(row?.date)}
                        </FixedTableCell>
                        {row?.deliveryAgent || row?.customer ? (
                          <CellLink
                            pathname={
                              listType === "dlvby"
                                ? `/admin/delivery-agents/${row?.deliveryAgent?.id}`
                                : `/admin/customers/${row?.customer?.id}`
                            }
                          >
                            {listType === "dlvby"
                              ? row?.deliveryAgent?.name
                              : row?.customer?.name}
                          </CellLink>
                        ) : (
                          <FixedTableCell> </FixedTableCell>
                        )}

                        {row?.safe ? (
                          <CellLink pathname={`/admin/safes/${row?.safe?.id}`}>
                            {row?.safe?.name}
                          </CellLink>
                        ) : (
                          <FixedTableCell> </FixedTableCell>
                        )}
                        {listType !== "dlvby" && (
                          <FixedTableCell>{row?.dueFees}</FixedTableCell>
                        )}
                        {listType === "dlvby" && (
                          <FixedTableCell>{row?.shipmentCount}</FixedTableCell>
                        )}
                        {listType === "dlvby" && (
                          <FixedTableCell>{row?.pickupCount}</FixedTableCell>
                        )}
                        <FixedTableCell>{row?.paymentAmount}</FixedTableCell>
                        <FixedTableCell>
                          {row?.approved ? (
                            <Icon className={classes.iconColor}>
                              check_circle_outline
                            </Icon>
                          ) : (
                            <Icon color="error">highlight_off</Icon>
                          )}
                        </FixedTableCell>
                        <FixedTableCell>
                          {row?.glApproved ? (
                            <Icon className={classes.iconColor}>
                              check_circle_outline
                            </Icon>
                          ) : (
                            <Icon color="error">highlight_off</Icon>
                          )}
                        </FixedTableCell>
                      </TableRow>
                    ))}
                  <TableRow>
                    <FixedTableCell colSpan={3} />
                    <FixedTableCell variant="head">{t("total")}</FixedTableCell>
                    {listType !== "dlvby" &&
                      <FixedTableCell variant="head">{sumPayments?.dueFees}</FixedTableCell>}
                    {listType === "dlvby" &&
                      <FixedTableCell variant="head">{sumPayments?.shipmentCount}</FixedTableCell>
                    }
                    {listType === "dlvby" &&
                      <FixedTableCell variant="head">{sumPayments?.pickupCount}</FixedTableCell>
                    }
                    <FixedTableCell variant="head">
                      {sumPayments?.paymentAmount}
                    </FixedTableCell>
                    <FixedTableCell colSpan={3}> </FixedTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableFixedHeaderWraper>
          )}
          <MUITablePagination
            count={data?.listPayments?.paginatorInfo?.total}
            rowsPerPage={rowsPerPage}
            page={!data?.listPayments ? 0 : page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Grid>
    </Grid>
  );

  const customerField = (type) => {
    if (type === "custm") {
      return (
        <Grid item sm={12} xs={12}>
          <CustomAutocomplete
            control={control}
            errors={errors}
            name={"customerId"}
            label={t("customer")}
            query={LIST_CUSTOMERS_DROPDOWN.query}
            skip={listType !== "custm"}
            onCompleted={(data) =>
              handelAutocompleteDefaultValue(
                data,
                urlQuery["customerId"],
                "customer"
              )
            }
            parseData={(data) => parseData(data)}
            variables={{
              input: {
                active: true,
              },
            }}
            defaultValue={autocompleteValues.customer}
          />
        </Grid>
      );
    } else if (type === "dlvby") {
      return (
        <Grid item sm={12} xs={12}>
          <CustomAutocomplete
            control={control}
            errors={errors}
            name={"deliveryAgentId"}
            label={t("shippingAgent")}
            skip={listType !== "dlvby"}
            onCompleted={(data) =>
              handelAutocompleteDefaultValue(
                data,
                urlQuery["deliveryAgentId"],
                "deliveryAgent"
              )
            }
            parseData={(data) => parseData(data)}
            query={LIST_DELIVERY_AGENTS_DROPDOWN.query}
            variables={{
              input: {
                active: true,
              },
            }}
            defaultValue={autocompleteValues.deliveryAgent}
          />
        </Grid>
      );
    }
  };

  return (
    <Root>
      {props.children}

      <Drawer
        className={clsx(classes.drawer)}
        variant="persistent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor={filterAnchor}
        open={state[filterAnchor]}
        onClose={() => false}
      >
        <div className={classes.drawerHeader} />

        <Toolbar className={clsx(classes.toolbar)} variant="dense">
          <Typography
            className={classes.titles}
            color="inherit"
            variant="h6"
            component="div"
          >
            {t("search")}
          </Typography>
          <IconButton
            aria-label="done"
            size="small"
            // disabled={Boolean(numSelected <= 0)}
            onClick={toggleDrawer(filterAnchor, false)}
            color={"primary"}
          >
            <Clear />
          </IconButton>
        </Toolbar>

        <Grid
          container
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          className={classes.filterForm}
        >
          <Grid
            container
            item
            sm={12}
            justifyContent="flex-start"
            spacing={1}
            className={classes.filterField}
          >
            <Grid item sm={12} xs={12}>
              <MUIDateRangeCustom
                value={dateRange}
                onChangeValue={(value) => setDateRange(value)}
                resetDate={resetDate}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <ControlMUItextField
                control={control}
                errors={errors}
                name={"code"}
                label={t("code")}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <MUIselect
                control={control}
                errors={errors}
                name={"approved"}
                label={t("status")}
                data={[
                  { key: t("approved"), value: true },
                  { key: t("notApproved"), value: false },
                ]}
                defaultValue={urlQuery?.approved}
              />
            </Grid>
            <Grid container item sm={12}>
              <CustomAutocomplete
                name={"branchId"}
                label={t("currentBranch")}
                control={control}
                errors={errors}
                parseData={(data) => parseData(data)}
                onCompleted={(data) =>
                  handelAutocompleteDefaultValue(
                    data,
                    urlQuery["branchId"],
                    "branch"
                  )
                }
                query={LIST_BRANCHES_DROPDOWN.query}
                defaultValue={autocompleteValues.branch}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <MUIselect
                control={control}
                errors={errors}
                name={"glApproved"}
                label={t("glApprove")}
                data={[
                  { key: t("glApproved"), value: true },
                  { key: t("notGlApproved"), value: false },
                ]}
                defaultValue={urlQuery?.approved}
              />
            </Grid>
            {customerField(listType)}
            <Grid item sm={12} xs={12}>
              <CustomAutocomplete
                control={control}
                errors={errors}
                name={"safeId"}
                label={t("safe")}
                onCompleted={(data) =>
                  handelAutocompleteDefaultValue(
                    data,
                    urlQuery["safeId"],
                    "safe"
                  )
                }
                parseData={(data) => parseData(data)}
                query={LIST_SAFES_DROPDOWN.query}
                defaultValue={autocompleteValues.safe}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <CustomAutocomplete
                control={control}
                errors={errors}
                name={"fromZoneId"}
                label={t("fromZone")}
                onChangeValue={(e) => {
                  setValue("fromSubzoneId", "");
                  delete urlQuery["fromSubzoneId"];

                  pushUrlSearch({ ...urlQuery });
                }}
                onCompleted={(data) =>
                  handelAutocompleteDefaultValue(
                    data,
                    urlQuery["fromZoneId"],
                    "fromZone"
                  )
                }
                variables={{ input: { parentId: null } }}
                parseData={(data) => parseData(data)}
                query={LSIT_ZONES_DROPDOWN.query}
                defaultValue={autocompleteValues.fromZone}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <CustomAutocomplete
                control={control}
                errors={errors}
                name={"fromSubzoneId"}
                label={t("fromSubzone")}
                skip={!watch("fromZoneId")}
                disabled={!watch("fromZoneId")}
                variables={{ input: { parentId: watch("fromZoneId") } }}
                onCompleted={(data) =>
                  handelAutocompleteDefaultValue(
                    data,
                    urlQuery["fromSubzoneId"],
                    "fromSubzone"
                  )
                }
                parseData={(data) => parseData(data)}
                query={LSIT_ZONES_DROPDOWN.query}
                defaultValue={autocompleteValues.fromSubzone}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <CustomAutocomplete
                control={control}
                errors={errors}
                name={"toZoneId"}
                label={t("toZone")}
                onChangeValue={(e) => {
                  delete urlQuery["toSubzoneId"];
                  setValue("toSubzoneId", "");

                  pushUrlSearch({ ...urlQuery });
                }}
                onCompleted={(data) =>
                  handelAutocompleteDefaultValue(
                    data,
                    urlQuery["toZoneId"],
                    "toZone"
                  )
                }
                variables={{ input: { parentId: null } }}
                parseData={(data) => parseData(data)}
                query={LSIT_ZONES_DROPDOWN.query}
                defaultValue={autocompleteValues.toZone}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <CustomAutocomplete
                control={control}
                errors={errors}
                name={"toSubzoneId"}
                label={t("toSubzone")}
                skip={!watch("toZoneId")}
                disabled={!watch("toZoneId")}
                onCompleted={(data) =>
                  handelAutocompleteDefaultValue(
                    data,
                    urlQuery["toSubzoneId"],
                    "toSubzone"
                  )
                }
                variables={{ input: { parentId: watch("toZoneId") } }}
                parseData={(data) => parseData(data)}
                query={LSIT_ZONES_DROPDOWN.query}
                defaultValue={autocompleteValues.toSubzone}
              />
            </Grid>
            <Can permission={listType === "custm"} showException>
              <Grid item sm={12} xs={12}>
                <LookupDropdown
                  control={control}
                  errors={errors}
                  name={"paymentMethodCode"}
                  label={t("paymentType")}
                  variables={{
                    input: { code: "SHP_PAYMENT_METHODS" },
                  }}
                  onCompleted={(data) =>
                    lookupsComplete(
                      data,
                      urlQuery["paymentMethodCode"],
                      "paymentMethodCode"
                    )
                  }
                />
              </Grid>
            </Can>
          </Grid>

          <Grid
            container
            item
            sm={12}
            className={classes.button}
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="medium"
              color="primary"
              startIcon={<Search />}
            >
              {t("search")}
            </Button>
          </Grid>
        </Grid>
      </Drawer>

      <Grid
        container
        justifyContent="center"
        className={clsx(classes.content, classes.mainTracking, {
          [classes.contentShift]: state[filterAnchor],
        })}
      >
        {paymentBody}
      </Grid>
    </Root>
  );
};

export default PaymentList;
